import {getStatusCategoryCodeToName, SaleStatusCategory} from '@web/slices/saleHistory/slice'
import makeSlice from '@web/slices/search/sliceMaker'

const searchSlice = makeSlice({
    initialState: {
        date: {
            type: 'MAX',
            max: 'FIVE_YEAR',
        },
        category: {
            title: '주문상태',
            items: [
                {
                    type: 'DEFAULT',
                    name: '전체',
                    code: 'ALL',
                },
                ...Object.values(SaleStatusCategory).map<{
                    type: 'SINGLE'
                    name: string
                    code: string
                }>((code) => {
                    return {
                        type: 'SINGLE',
                        name: getStatusCategoryCodeToName(code),
                        code,
                    }
                }),
            ],
        },
    },
    extraReducers: () => {
        /* empty */
    },
})

export default searchSlice.reducer
